import logo from "../Images/sprout-wo-bg-logo.png";

export default function Navbar(props) {
  const words = props.wordsCount;
  const progressDataLabel = `${Math.floor((words / props.wordLim) * 100)}%`;
  // console.log(Math.floor((words / props.wordLim) * 100));

  return (
    <nav>
      <div className="navLogoHead">
        <img src={logo} alt="Sprout logo" className="navLogo" />
        <h1 className="navHead">Sprout</h1>
      </div>
      <div className="progressBar">
        <span className="dailyGoal">Daily Goal</span>
        <progress value={words} max={props.wordLim}></progress>
        <div className="dataLabels">
          <span>
            `{words}/{props.wordLim} Words`
          </span>
          <span>{progressDataLabel}</span>
        </div>
      </div>
    </nav>
  );
}
